export const faqs = [
  {
    question: '91免费看片app是否真的完全免费？',
    answer: '是的，91免费推荐的看片软件均为免费版本或提供充足的免费试用功能。我们严格筛选真正免费的软件，确保用户无需付费即可享受流畅的观影体验。部分软件可能提供高级会员功能，但基础看片功能完全免费。',
  },
  {
    question: '91免费看片的app支持哪些设备平台？',
    answer: '91免费看片软件覆盖全平台需求：安卓手机和平板（Android 5.0及以上）、苹果iPhone和iPad（iOS 12.0及以上）、Windows电脑（Windows 7/10/11）、Mac电脑（macOS 10.14及以上）。每个平台的软件我们都经过实测验证，确保兼容性良好。',
  },
  {
    question: '如何下载91免费软件？下载安装流程是怎样的？',
    answer: '下载流程非常简单：第一步，在91免费网站找到心仪的软件文章；第二步，点击文章内的下载链接或扫描二维码；第三步，根据页面指引完成下载安装。安卓用户需要开启"允许安装未知来源应用"选项，苹果用户可通过TestFlight或企业证书方式安装。详细步骤每篇文章都有图文教程。',
  },
  {
    question: '91免费看片软件看视频会卡顿吗？',
    answer: '91免费推荐的软件均经过流畅度测试，在正常网络环境下（4G/5G/WiFi）均可流畅播放。我们特别筛选了采用P2P加速技术和多源切换技术的软件，即使在网络波动情况下也能保持稳定播放。建议用户选择"稳定版本"分类中的软件，流畅度更有保障。',
  },
  {
    question: '91免费客户端的app安全吗？会不会有病毒？',
    answer: '安全是我们最重视的问题。91免费推荐的每一款软件都经过严格的安全检测，包括病毒扫描、权限审查和隐私评估。我们只推荐无恶意代码、无不合理权限请求的软件。但请注意，务必从91免费提供的官方渠道下载，避免从不明来源获取安装包。',
  },
  {
    question: '免费看片软件的资源更新速度快吗？',
    answer: '91免费持续跟踪各软件的资源更新情况。我们推荐的软件大多具备自动更新功能，影视资源库每日更新，热门新片通常在24小时内即可观看。我们也会定期更新文章内容，确保用户获取的都是最新版本的软件信息。',
  },
  {
    question: '看片app免费安装后需要注册账号吗？',
    answer: '大部分91免费推荐的看片软件支持免注册直接观看，部分软件提供注册功能以同步观看记录和收藏。注册通常只需手机号或邮箱，过程简单快捷。如果不希望注册，可以直接使用游客模式观看，不影响核心看片功能。',
  },
  {
    question: '91免费看片软件推荐多久更新一次？',
    answer: '我们保持每周至少更新一次推荐列表，及时下架失效或体验下降的软件，同时纳入新发现的优质免费看片工具。用户可通过关注91免费网站的"最新推荐"分类，第一时间获取最新的软件推荐信息。',
  },
];